import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const LeftArrow = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29 15H5.60001L13.663 7.737C13.863 7.549 14.001 7.287 14.001 7C14.001 6.45 13.551 6 13.001 6C12.739 6 12.513 6.1 12.339 6.263L2.33901 15.263C2.12701 15.451 2.01401 15.726 2.01401 16.001C2.01401 16.276 2.13901 16.551 2.33901 16.739L12.339 25.739C12.514 25.902 12.751 26.001 13.001 26.001C13.551 26.001 14.001 25.551 14.001 25.001C14.001 24.701 13.876 24.438 13.663 24.263L5.60001 17.001H29C29.55 17.001 30 16.551 30 16.001C30 15.451 29.55 15.001 29 15.001V15Z" />
	</svg>
);

export default LeftArrow;
